<template>
<img src="https://snippcheck.blob.core.windows.net/files/Kelloggs_CA_Free_Towel_GWP_2007544/images/FooterDesktopBG.png" class="img-fluid w-100 d-md-block d-none desktop-footer-image" role="none" alt="footer-image" />
<img src="https://snippcheck.blob.core.windows.net/files/Kelloggs_CA_Free_Towel_GWP_2007544/images/FooterMobile_3.png" class="img-fluid w-100 d-md-none mobile-footer-image mt-n5" role="none" alt="footer-image" />
  <footer class="py-4">
  
		<div class="abbv container mb-4" >    
          <div class="text-center" v-html="$t('Footer.legalrules')"></div>   
        </div>
      <div class="navbar">
        <div class="col-sm-12 p-0 text-center">
      <ul class="list-inline mb-0" id="footer-nav">      
        <li class="list-inline-item" v-html="$t('Footer.T&CLink')">   
        </li>
		<li class="list-inline-item" v-html="$t('Footer.PrivayPolicyLink')">   
        </li>
		<li class="list-inline-item" v-html="$t('Footer.TermsOfUseLink')">   
        </li>
		<li class="list-inline-item" v-html="$t('Footer.CookiePreference')">
		</li>  
		<li class="list-inline-item" v-html="$t('Footer.AccessibilityLink')">   
        </li>		
        <li class="list-inline-item" v-html="$t('Footer.DNSLink')">   
        </li>
		<li class="list-inline-item" v-html="$t('Footer.ContactUsLink')">   
        </li>
        
      </ul>
      <p class="mb-0 px-3">
        <small
          >{{$t('Footer.copyrighttext')}} © {{ new Date().getFullYear() }} {{$t('Footer.AllrightReserved')}}</small
        >
      </p>

    </div> </div>
    <!-- <div class="footer-right ">
      <div class="footer-social-nav">
        <ul class="list-inline m-0">
          <li>
            <a
              href="#"
              class="fb-link social-icon"
              title="facebook"
              target="_blank"
            >
              <i class="fab fa-facebook-square"></i>
            </a>
          </li>
          <li>
            <a
              href="#"
              class="twitter-link social-icon"
              title="twitter"
              target="_blank"
            >
              <i class="fab fa-square-x-twitter"></i>
            </a>
          </li>
          <li>
            <a
              href="#"
              class="ig-link social-icon"
              title="instagram"
              target="_blank"
            >
              <i class="fab fa-instagram-square"></i>
            </a>
          </li>
          <li>
            <a
              href="#"
              class="yt-link social-icon"
              title="youtube"
              target="_blank"
            >
              <i class="fab fa-youtube-square"></i>
            </a>
          </li>
        </ul>
      </div>
     
    </div> -->
 
  </footer>
  <img src="https://snippcheck.blob.core.windows.net/files/Kelloggs_CA_Free_Towel_GWP_2007544/images/FooterMobile_2.png" class="img-fluid w-100 d-md-none mobile-footer-image mt-n4" role="none" alt="footer-image" />
</template>

<script>
//Younet chatbot code apprended in the body
export default {
  mounted() {
    // // Dynamically fetch the translated modelHash
    // const modelHash = this.$t('YounetmodelHash');
    // const modelImgurl = this.$t('YounetmodelIMg');
    // const scriptUrl = `https://widget.younet.ai/index.js?modelHash=${modelHash}&type=bubble&imgUrl=${modelImgurl}`;

    // // Dynamically create the script element
    // const script = document.createElement('script');
    // script.type = 'module';
    // script.src = scriptUrl;

    // // Append the script to the body
    // document.body.appendChild(script);
  },
};
</script>


